import type { IEnvironment } from '@tarslib/types/lib/environment';
import type { IHttpFolderMap } from '@tarslib/types/lib/httpFolder';
import type { ServerItem } from '@tarslib/types/lib/projectSetting';

export enum MultiServer {
  InheritParent = '',
  Default = 'default',
}

const ROOT_FOLDER_ID = 0;

const checkExist = (serverId: string, servers?: ServerItem[]) => {
  const index = servers?.findIndex(({ id }) => id === serverId) ?? -1;
  return index > -1;
};

export const checkInheritParent = (serverId: string | undefined, servers?: ServerItem[]) => {
  if (!serverId) return true;
  if (serverId === MultiServer.InheritParent) {
    return true;
  }
  if (!checkExist(serverId, servers)) {
    return true;
  }
  return false;
};

export const getTargetFolder = ({
  folderId,
  folderMap,
  servers,
}: {
  folderId: number;
  folderMap: IHttpFolderMap;
  servers?: ServerItem[];
}): any => {
  if (!folderMap[folderId]) return {};

  if (folderId === ROOT_FOLDER_ID) {
    return folderMap[folderId];
  }

  const { parentId, serverId } = folderMap[folderId];
  if (checkInheritParent(serverId, servers)) {
    return getTargetFolder({ folderId: parentId, folderMap, servers });
  }

  return folderMap[folderId];
};

export const getRequestBaseUrl = ({
  serverId,
  environment,
  servers,
  path,
}: {
  serverId: string;
  servers?: ServerItem[];
  environment?: IEnvironment;
  path?: string;
}) => {
  if (!environment) return '';

  if (path && /^https?:\/\//.test(path)) {
    return '';
  }

  const { baseUrls = {}, type } = environment;

  if (type === 'mock') {
    return baseUrls[MultiServer.Default] || '';
  }

  if (checkExist(serverId, servers)) {
    return baseUrls[serverId] || '';
  }

  if (path && path.startsWith('{{')) {
    return '';
  }

  return baseUrls[MultiServer.Default] || '';
};
